import routes from "../common/api-routes";
import {HttpAuthPost, HttpAuthGet, HttpAuthPutParamsPayload, HttpAuthPutParams} from "../../../../core/services/common/HttpRequestBuilder";

const generateSingleGatePass = (payload) => {
    let result = HttpAuthPost(routes.GENERATE_SINGLE_GATE_PASS, payload);
    return result;
}

const listGatePass = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_GATE_PASS, parameters);
    return result;
}

const viewGatePass = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_GATE_PASS, parameters);
    return result;
}

const updateGatePassStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_GATE_PASS_STATUS, parameters);
    return result;
}

const generateBookingGatePass = (payload) => {
    let result = HttpAuthPost(routes.GENERATE_BOOKING_GATE_PASS, payload);
    return result;
}

const getListVehicleBooking = (parameters) => {
    let result = HttpAuthGet(routes.GET_VEHICLE_LIST_BOOKING, parameters);
    return result;
}

const generateVehicleGatePass = (payload) => {
    let result = HttpAuthPost(routes.GENERATE_VEHICLE_GATEPASS, payload);
    return result;
}

const updateGatePass = (parameters, payload) => {
    let result = HttpAuthPutParamsPayload(routes.UPDATE_GATE_PASS, parameters, payload);
    return result;
}

const filterGatePass = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_GATE_PASS, parameters);
    return result;
}

const getGatePassPassType = () => {
    const parameters = null;
    let result = HttpAuthGet(routes.GET_GATEPASS_PASS_TYPE, parameters);
    return result;
}

const getGatePassEntryType = () => {
    const parameters = null;
    let result = HttpAuthGet(routes.GET_GATEPASS_ENTRY_TYPE, parameters);
    return result;
}

const listOrgGatePass = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_ORG_GATE_PASS, parameters);
    return result;
}

const generateOrgBookingGatePass = (payload) => {
    let result = HttpAuthPost(routes.GENERATE_ORG_BOOKING_GATE_PASS, payload);
    return result;
}

const getListOrgVehicleBooking = (parameters) => {
    let result = HttpAuthGet(routes.GET_ORG_VEHICLE_LIST_BOOKING, parameters);
    return result;
}

const generateOrgVehicleGatePass = (payload) => {
    let result = HttpAuthPost(routes.GENERATE_ORG_VEHICLE_GATE_PASS, payload);
    return result;
}

const filterOrgGatePass = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_ORG_GATE_PASS, parameters);
    return result;
}

const getGatePassVehicleAccessLogs = (parameters) => {
    let result = HttpAuthGet(routes.GET_GATEPASS_VEHICLE_ACCESS_LOGS, parameters);
    return result;
}

const getOrgGatePassVehicleAccessLogs = (parameters) => {
    let result = HttpAuthGet(routes.GET_ORG_GATEPASS_VEHICLE_ACCESS_LOGS, parameters);
    return result;
}

const updateOrgGatePassStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_ORG_GATE_PASS_STATUS, parameters);
    return result;
}


const GatePassService = {
    generateSingleGatePass: generateSingleGatePass,
    listGatePass: listGatePass,
    viewGatePass: viewGatePass,
    updateGatePassStatus: updateGatePassStatus,
    generateBookingGatePass: generateBookingGatePass,
    getListVehicleBooking: getListVehicleBooking,
    generateVehicleGatePass: generateVehicleGatePass,
    updateGatePass: updateGatePass,
    filterGatePass: filterGatePass,
    getGatePassPassType: getGatePassPassType,
    getGatePassEntryType: getGatePassEntryType,
    getGatePassVehicleAccessLogs: getGatePassVehicleAccessLogs,

    // organization gatepass
    listOrgGatePass: listOrgGatePass,
    generateOrgBookingGatePass: generateOrgBookingGatePass,
    getListOrgVehicleBooking: getListOrgVehicleBooking,
    generateOrgVehicleGatePass: generateOrgVehicleGatePass,
    filterOrgGatePass: filterOrgGatePass,
    getOrgGatePassVehicleAccessLogs: getOrgGatePassVehicleAccessLogs,
    updateOrgGatePassStatus: updateOrgGatePassStatus
}

export default GatePassService